const prefix = "DASHBOARD_";

export const ACTIVITY_FOR_WEEK_GET = prefix + "ACTIVITY_FOR_WEEK_GET";
export const ACTIVITY_FOR_WEEK_REFRESH = prefix + "ACTIVITY_FOR_WEEK_REFRESH";
export const ACTIVITY_FOR_YEAR_GET = prefix + "ACTIVITY_FOR_YEAR_GET";
export const ACTIVITY_FOR_YEAR_REFRESH = prefix + "ACTIVITY_FOR_YEAR_REFRESH";
export const INVOICE_STATUS_GET = prefix + "INVOICE_STATUS_GET";
export const INVOICE_STATUS_REFRESH = prefix + "INVOICE_STATUS_REFRESH";
export const LEVY_COMPONENTS_GET = prefix + "LEVY_COMPONENTS_GET";
export const LEVY_COMPONENTS_REFRESH = prefix + "LEVY_COMPONENTS_REFRESH";
export const NOTICE_COUNTS_GET = prefix + "NOTICE_COUNTS_GET";
export const NOTICE_COUNTS_REFRESH = prefix + "NOTICE_COUNTS_REFRESH";
export const PAYMENT_STATUS_GET = prefix + "PAYMENT_STATUS_GET";
export const PAYMENT_STATUS_REFRESH = prefix + "PAYMENT_STATUS_REFRESH";
export const PROVIDER_LEVY_AMOUNTS_GET = prefix + "PROVIDER_LEVY_AMOUNTS_GET";
export const PROVIDER_LEVY_AMOUNTS_REFRESH = prefix + "PROVIDER_LEVY_AMOUNTS_REFRESH";
export const PROVIDER_STATUS_GET = prefix + "PROVIDER_STATUS_GET";
export const PROVIDER_STATUS_REFRESH = prefix + "PROVIDER_STATUS_REFRESH";
